module.exports = __webpack_public_path__ + "img/pmg-open.18792bf0.png";